/**
 * 验证工具函数集合
 */

// 验证码格式验证
export const validateVerificationCode = (code: string): { isValid: boolean; error?: string; } => {
  const trimmed = code.trim();

  if (!trimmed) {
    return { isValid: false };
  }

  if (trimmed.length !== 6) {
    return { isValid: false };
  }

  return { isValid: true };
};

// 邀请码格式验证
export const validateInviteCode = (code: string): { isValid: boolean; error?: string; } => {
  const trimmed = code.trim();

  // 邀请码是可选的，空值视为有效
  if (!trimmed) {
    return { isValid: true };
  }

  if (trimmed.length !== 8) {
    return { isValid: false };
  }

  const inviteCodeRegex = /^[a-zA-Z0-9]{8}$/;
  if (!inviteCodeRegex.test(trimmed)) {
    return { isValid: false };
  }

  return { isValid: true };
};

// 清理代码输入（只保留字母数字，限制长度）
export const cleanCodeInput = (value: string, maxLength = 6): string => {
  return value.replace(/[^a-zA-Z0-9]/g, '').slice(0, maxLength);
};
